import { Link } from 'react-router-dom'

export default function About() {
  return (
    <div className="animate-in" style={{ maxWidth: 720, margin: '0 auto' }}>
      <h1 style={{ fontFamily: 'var(--display)', fontSize: 32, fontWeight: 700, marginBottom: 8, letterSpacing: '-0.5px' }}>
        About EarningsEdge
      </h1>
      <p style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--mono)', marginBottom: 32, letterSpacing: '1px', textTransform: 'uppercase' }}>
        Tracking Earnings Movements
      </p>

      <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.8, marginBottom: 32 }}>
        EarningsEdge tracks how stocks move around earnings reports — before the open, during market hours, and after the close.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 32 }}>
        {[
          { icon: '📊', title: 'Earnings Dashboard', desc: 'See pre-market, market, post-market, and prior day movers sorted by price reaction.', path: '/' },
          { icon: '🎯', title: 'Predict & Track', desc: 'Predict how stocks will move before earnings. Track your accuracy over time.', path: '/predict' },
          { icon: '🏆', title: 'Leaderboard', desc: 'Compete with other users. Rankings based on hypothetical $10k-per-trade returns.', path: '/leaderboard' },
          { icon: '📅', title: '7-Day Calendar', desc: 'See upcoming earnings up to a week out. Make predictions in advance.', path: '/predict' },
        ].map(({ icon, title, desc, path }) => (
          <div key={title} style={{
            background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 6, padding: '18px',
          }}>
            <div style={{ fontSize: 20, marginBottom: 8 }}>{icon}</div>
            <Link to={path} style={{ textDecoration: 'none' }}>
              <div style={{
                fontWeight: 600, fontSize: 13, marginBottom: 6, color: 'var(--olive)',
                cursor: 'pointer',
              }}
                onMouseEnter={e => e.target.style.textDecoration = 'underline'}
                onMouseLeave={e => e.target.style.textDecoration = 'none'}
              >{title}</div>
            </Link>
            <div style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.6 }}>{desc}</div>
          </div>
        ))}
      </div>

      <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.7 }}>
        Have feedback? Email us at{' '}
        <a href="mailto:earningsedge12@gmail.com" style={{ color: 'var(--olive)' }}>earningsedge12@gmail.com</a>.
      </p>
    </div>
  )
}
